import { AuthorityQueryProvider } from "__legacy/queries/authorities/AuthorityQueryProvider";
import { UpdateAuthorityMutationProvider } from "__legacy/queries/authorities/UpdateAuthorityMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { BodyForm, onError, onFinish } from "./BodyForm";

export const Edit: React.FC<{}> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <AuthorityQueryProvider variables={{ id }}>
      {({ authority }) => (
        <UpdateAuthorityMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`Edit body ${authority.name}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../")}>Back to list</Button>
                    <Button onClick={() => navigate("../")}>Back to details</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <BodyForm
                  action="update"
                  form={form}
                  handler={onFinish(mutate, {}, { id })}
                  values={authority}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </UpdateAuthorityMutationProvider>
      )}
    </AuthorityQueryProvider>
  );
};
